import { useContext, useCallback } from 'react';
import _get from 'lodash/get';
import { AjaxContext, AppContext, UserContext } from 'commons-ui';
import { MISCELLANEOUS_RESOURCES, PAGE_NAMES } from 'constant';
import { IUpdateProps, ICreateProps } from '../types';
import { CONFISCATION_RESOURCES } from '../submodules/selectConfiscation/helper';

const useService = () => {
	const { user } = useContext(UserContext);
	const { postData } = useContext(AjaxContext);
	const {
		app: { appName }
	} = useContext(AppContext);
	const createConfiscationAndRefundRequest = useCallback(async (formData: ICreateProps) => {
		const result = await postData({
			endpoint: `/dashboard/createConfiscationAndRefundRequest/${MISCELLANEOUS_RESOURCES.confiscationAndRefund}-${CONFISCATION_RESOURCES.manualConfiscation}-createConfiscationAndRefundRequest`,
			queryParams: {
				appName
			},
			body: {
				...formData,
				createdBy: _get(user, 'email', '')
			}
		});

		return result;
	}, []);

	const updateConfiscationAndRefundRequest = useCallback(async (formData: IUpdateProps) => {
		const result = await postData({
			endpoint: `/dashboard/updateConfiscationAndRefundRequest/${PAGE_NAMES.miscellaneous}-${MISCELLANEOUS_RESOURCES.confiscationAndRefund}-updateConfiscationAndRefundRequest`,
			queryParams: {
				appName
			},
			body: { ...formData, approvedOrRejectedBy: _get(user, 'email', '') }
		});

		return result;
	}, []);

	const uploadCsvDetails = useCallback((formData: any) => {
		formData.append('createdBy', _get(user, 'email', ''));
		return postData({
			endpoint: `/dashboard/createConfiscationAndRefundRequestInBulk/${MISCELLANEOUS_RESOURCES.confiscationAndRefund}-${CONFISCATION_RESOURCES.bulkConfiscation}-createConfiscationAndRefundRequestInBulk`,
			body: formData,
			customHeaders: { 'Content-Type': 'multipart/form-data' },
			queryParams: {
				appName
			}
		});
	}, []);

	return {
		createConfiscationAndRefundRequest,
		updateConfiscationAndRefundRequest,
		uploadCsvDetails
	};
};

export default useService;
